import React from 'react';
import { Modal, ModalBody } from "reactstrap";
import ArchieveTable from "./ArchieveTable/ClientSideTable";
import { CSVLink } from 'react-csv';


const MediaDialog = props => {
    const { modal, setmodal, className, currentMedia } = props
    /*
    const [data, setData] = useState([]);
    console.log(currentMedia)
    useEffect(() => {
        if (currentMedia) {
            var _data = [[...currentMedia.cols]];

            var _rows = [];

            for (var index in currentMedia.rows) {
                if (!_rows[index]) {_rows[index] = {}};
                for (var col in currentMedia.cols) {
                    
                    if(Object.keys(currentMedia.rows[index]).indexOf(currentMedia.cols[col]) === -1) {
                        _rows[index][col] = null;
                    } else {
                        _rows[index][col] = currentMedia.rows[index][currentMedia.cols[col]];
                    }
                }
            _data.push(Object.keys(_rows[index]).map((k) => _rows[index][k]));

            }
            setData(_data);
        }
    }, [currentMedia])

    */

    return (
        <Modal
            centered
            isOpen={modal}
            toggle={setmodal}
            className={className}
            size="lg"
            fade={false}
            style={{maxWidth: "1500px"}}
        >
            <ModalBody className="media-modal-body">
                <div>
                    {
                        currentMedia &&
                        <CSVLink 
                            data={currentMedia.rows} 
                            headers={currentMedia.cols} 
                            filename={currentMedia.name+".csv"}
                            className="btn c-primary"
                            target="_blank"
                            style={{textAlign:"center"}}
                        >İndir</CSVLink>
                    }
                    <button onClick={setmodal} className="c-primary" style={{float:"right"}}>X</button>

                </div>
                <ArchieveTable data={currentMedia}></ArchieveTable>
            </ModalBody>
        </Modal>
    );
};

export default MediaDialog;